import FirmApi from '../../services/FirmApi'
import ApiService from '@/services/ApiService'

export const search = {
    namespaced: true,
    state: {
        searchText: '',
        founded_firms: null,
    },
    mutations: {
        setSearchText(state, payload) {
            state.searchText = payload
        },
        setFoundedFirms(state, payload) {
            state.founded_firms = payload
        },
    },
    actions: {
        setSearchText({ commit }, payload) {
            commit('setSearchText', payload)
        },
        /**
         * hledá firmy a vrací true, jinak false
         * @param commit
         * @param dispatch
         * @param searchtext
         * @returns {Promise<any>}
         */
        getFirms({ commit }, searchtext) {
            return new Promise((resolve, reject) => {
                ApiService.fetchIco(searchtext)
                    .then(function(response) {
                        console.log(response)
                        const { status, results } = response.data
                        if (status == true) {
                            // vm.form.founded_firms = response.data.results;
                            commit('setFoundedFirms', results)
                            resolve(true)
                        } else {
                            resolve(false)
                        }
                    })
                    .catch(function(error) {
                        reject(error)
                    })
            })
        },
    },
}
